import FormattedName from 'I18n/components/FormattedName';
import SkeletonText from 'conversations-skeleton-state/components/SkeletonText';
import { getEmail, getFirstName, getLastName } from 'conversations-message-history/senders/operators/getters';
import { UnknownSenderText } from 'conversations-message-history/senders/components/UnknownSenderText';
import { jsx as _jsx } from "react/jsx-runtime";
const FriendlySenderName = ({
  sender,
  isLoading
}) => {
  if (isLoading) {
    return /*#__PURE__*/_jsx(SkeletonText, {
      "data-test-id": "skeleton-text",
      inlineSize: "100px"
    });
  }
  const givenName = sender && getFirstName(sender);
  const familyName = sender && getLastName(sender);
  const email = sender && getEmail(sender);
  const hasKnownName = Boolean(givenName || familyName || email);
  return hasKnownName ? /*#__PURE__*/_jsx(FormattedName, {
    givenName: givenName || undefined,
    familyName: familyName || undefined,
    email: email || undefined
  }) : /*#__PURE__*/_jsx(UnknownSenderText, {
    sender: sender
  });
};
FriendlySenderName.displayName = 'SenderName';
export default FriendlySenderName;